export default __webpack_public_path__ + "static/media/admin-main-sm.46d58dfb.jpg";